import React from 'react';
import parse from 'html-react-parser';
import { IDisclosure } from '../../interfaces';

type DisclosureWithSymbolProps = {
  className?: string;
  symbol?: string;
  disclosure: IDisclosure;
  notSuperscriptSymbol?: boolean;
};
export default class DisclosureWithSymbol extends React.Component<DisclosureWithSymbolProps> {
  render() {
    const cl = this.props.className ? `${this.props.className} ` : '';
    const returnSymbol = (s: string) => {
      const symb =
        this.props.notSuperscriptSymbol || this.props.symbol === '*' ? s : `<sup>${s}</sup>`;
      return symb;
    };
    return (
      <p {...(cl ? { className: cl } : {})}>
        {parse(
          `${returnSymbol(this.props.symbol || this.props.disclosure.symbol || '')}${this.props.disclosure.copy}`
        )}
      </p>
    );
  }
}
